
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { setDateFormat } from "../../utils/Helper";
import Button from "../Ui/Button";
import $ from "jquery"
import { useDispatch, useSelector } from "react-redux";
import { FormattedMessage } from "react-intl";


import { useIntl } from 'react-intl';
import { useState } from "react";

const BillingManagementFilter = ({ register, handleSubmit, onSubmit, handleReset, setValue, watch, errors, setDisableDate, disableDate }: any) => {
    const intl = useIntl();

    // const dispatch = useDispatch<any>();
    // const categoryData = useSelector((state: any) => state.ProfileGetCategoryState);

    const [bookingType, setBookingType] = useState(1);

    const handleBookingChange = (event: any) => {
        setBookingType(parseInt(event.target.value));
    };



    const onSubmitData = (payload: any) => {
        const data = {
            ...payload,
            booking_type: bookingType
        }
        onSubmit(data);
        $(".btnClose").click();
    }




    return (
        <>
            <div className="modal modelStyle fade" id="servicelistFilter" tabIndex={-1} aria-labelledby="exampleModalLabel" data-bs-backdrop="static" aria-hidden="true" data-bs-keyboard="false">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1 className="modal-title fs-5" id="exampleModalLabel"><FormattedMessage id="filter" /></h1>
                            {/* <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button> */}
                            <button type="button" className="btn p-0 f-20 btnClose" data-bs-dismiss="modal" aria-label="Close"><span className="icon-close"></span></button>
                        </div>
                        <div className="modal-body">
                            <form onSubmit={handleSubmit(onSubmitData)}>
                                <div className='row gy-2'>
                                    <div className="normalINput">
                                        <label className="form-label"><FormattedMessage id="booking_type" /></label>
                                    </div>

                                    <div className='col-12 label-change'>
                                        <div className="form-check form-check-inline">
                                            <input className="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1"
                                                value={1}
                                                checked={bookingType === 1}
                                                onChange={handleBookingChange}
                                            />
                                            <label className="form-check-label" htmlFor="flexRadioDefault1">
                                            <FormattedMessage id="online" />
                                            </label>
                                        </div>
                                        <div className="form-check form-check-inline">
                                            <input className="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault2" value={2}
                                                checked={bookingType === 2} onChange={handleBookingChange} />
                                            <label className="form-check-label" htmlFor="flexRadioDefault2"> <FormattedMessage id="offline" /> </label>
                                        </div>

                                    </div>

                                    <div className='col-sm-6'>
                                        <div className='datepicker normalINput'>
                                            <label className="form-label"><FormattedMessage id="from" /></label>
                                            <DatePicker
                                                className='form-control'
                                                placeholderText="MM/DD/YYYY"
                                                timeFormat="MM DD YYYY"
                                                onKeyDown={(e: any) => e.preventDefault()}
                                                showYearDropdown
                                                scrollableYearDropdown
                                                yearDropdownItemNumber={50}
                                                selected={watch("start_date")}
                                                showIcon
                                                onChange={(start_date: any) => {
                                                    setDisableDate(false);
                                                    setValue('start_date', setDateFormat(start_date))
                                                    setValue('end_date', '')
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className='col-sm-6'>
                                        <div className='datepicker normalINput'>
                                            <label className="form-label"><FormattedMessage id="to" /></label>
                                            <DatePicker
                                                className="form-control"
                                                // placeholderText={intl.formatMessage({ id: 'month' })}
                                                placeholderText="MM/DD/YYYY"
                                                timeFormat="MM DD YYYY"
                                                onKeyDown={(e: any) => e.preventDefault()}
                                                showYearDropdown
                                                scrollableYearDropdown
                                                yearDropdownItemNumber={50}
                                                selected={(watch('end_date'))}
                                                showIcon
                                                disabled={disableDate}
                                                minDate={watch('start_date')}
                                                {...register('end_date')}
                                                toggleCalendarOnIconClick
                                                onChange={(end_date: any) => {
                                                    setValue('end_date', setDateFormat(end_date))
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <Button text={<FormattedMessage id="apply" /> as any} type="submit" className="btn btn-fill w-100 mt-5" data-bs-dismiss="modal" />

                                {/* <Button type="submit" text= {intl.formatMessage({ id: 'apply' })}  className="btn btn-fill w-100 mt-5" data-bs-dismiss="modal" /> */}
                                {/* <Button type="submit" text="Apply" className="btn btn-fill w-100 mt-5" data-bs-dismiss="modal" /> */}

                            </form>
                        </div>

                    </div>
                </div>
            </div>
        </>
    )
}

export default BillingManagementFilter